<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="tablePath">付款退款单列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <template v-if="showErrorMsg">
      <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
    </template>
    <template v-else>
    <layout-panel>
      <span slot="header">基本信息</span>
      <template slot="tools">
        <el-button size="mini"
                   type="primary"
                   @click="downloadRefundPDF"
                   :loading="onDownloadPdf">生成PDF
        </el-button>
      </template>
      <el-form ref="basicInfoForm"
               :model="detail"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="付款退款单ID："><span> {{ detail.id }} </span></el-form-item>
            <el-form-item label="创建人："><span> {{ `${detail.creator.user_name}/${detail.creator.id}` }} </span></el-form-item>
            <el-form-item label="创建人部门："><span> {{ detail.department_name }} </span></el-form-item>
            <el-form-item label="付款类型："><span> 付款退款 </span></el-form-item>
            <el-form-item label="付款公司："><span> {{ detail.payment_company_info.name }} </span></el-form-item>
            <el-form-item label="付款账户：" v-if="detail.payment_company_account">
              <span>{{detail.payment_company_account.name + '/' + detail.payment_company_account.number}}</span>
            </el-form-item>
            <el-form-item label="退款说明："><span> {{ detail.refund_desc }} </span></el-form-item>
            <el-form-item label="原付款申请单ID：">
              <router-link :to="`${paymentDetailPath}/${detail.payment_apply_id}`">
                <span> {{ detail.payment_apply_id }} </span>
              </router-link>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">付款信息</template>
      <el-form ref="basicInfoForm"
               :model="detail"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="付款对象："><span> {{ detail.paid_to_type_name }} </span></el-form-item>
            <el-form-item label="收款对象名称："><span> {{ detail.bank_account_snapshot.name }} </span></el-form-item>
            <el-form-item label="银行账号："><span> {{ detail.bank_account_snapshot.bank_account }} </span></el-form-item>
            <el-form-item label="开户银行支行："><span> {{ detail.bank_account_snapshot.bank }} </span></el-form-item>
            <el-form-item label="开户银行总行："><span> {{ detail.bank_account_snapshot.bank_headquarters }} </span></el-form-item>
            <el-form-item label="备注信息："><span> {{ detail.bank_account_snapshot.remark }} </span></el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">退款信息</template>
      <el-form ref="basicInfoForm"
               :model="detail"
               size="medium"
               label-width="100px">
        <el-row :gutter="21" style="margin-left: 0">
          <el-col :span="1" style="text-align:center;">序号</el-col>
          <el-col :span="3" style="text-align:center;">项目编号</el-col>
          <el-col :span="2" style="text-align:center;">费用承担部门</el-col>
          <el-col :span="2" style="text-align:center;">一级科目</el-col>
          <el-col :span="2" style="text-align:center;">二级科目</el-col>
          <el-col :span="2" style="text-align:center;">发票类型</el-col>
          <el-col :span="2" style="text-align:center;">税率%</el-col>
          <el-col :span="2" style="text-align:center;">发票张数</el-col>
          <el-col :span="2" style="text-align:center;">实付金额</el-col>
          <el-col :span="2" style="text-align:center;">付款申请摘要</el-col>
          <el-col :span="2" style="text-align:center;">财务摘要</el-col>
          <el-col :span="2" style="text-align:center;">退款金额</el-col>
        </el-row>
        <br>
        <el-row :gutter="21" v-for="(detailItem, itemIndex) in detail.refund_detail"
                :key="itemIndex"
                style="margin-top:5px">
          <el-col :span="1" style="text-align:center;">{{ itemIndex + 1 }}</el-col>
          <el-col :span="3" style="text-align:center;">{{ detailItem.project_display }}</el-col>
          <el-col :span="2" style="text-align:center;">{{ detailItem.department_name }}</el-col>
          <el-col :span="2" style="text-align:center;">{{ detailItem.first_subject_name }}</el-col>
          <el-col :span="2" style="text-align:center;">{{ detailItem.second_subject_name }}</el-col>
          <el-col :span="2" style="text-align:center;">{{ detailItem.invoice_type_name }}</el-col>
          <el-col :span="2" style="text-align:center;">{{ detailItem.tax_rate }}</el-col>
          <el-col :span="2" style="text-align:center;">{{ detailItem.invoice_count }}</el-col>
          <el-col :span="2" style="text-align:center;">￥{{ detailItem.paid_amount }}</el-col>
          <el-col :span="2" style="text-align:center;">{{ detailItem.desc }}</el-col>
          <el-col :span="2" style="text-align:center;">{{ detailItem.finance_desc }}</el-col>
          <el-col :span="2" style="text-align:center;">￥{{ detailItem.refund_amount }}</el-col>
        </el-row>
        <br>
        <el-row :gutter="21">
          <el-col>
            <p style="margin-right: 20px;text-align: right;">退款金额合计：￥{{ detail.refund_amount_total }}</p>
          </el-col>
        </el-row>

        <el-form-item label="退款单附件:"
                      key="attached_file"
                      prop="attached_file">
          <div class="view-navbar" v-if="detail.attached_file.length > 0">
            <ul class="clear-both">
              <li v-for="(item, index) in detail.attached_file" :key="index">
                <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                  <img v-if="item.type === 'pic' && item.pic_url" style="width: 100px; height: 100px" :src="item.pic_url | ossHost" @click="onViewImage">
                  <i v-else
                     class="sj-icon-pdf"
                     style=" font-size:100px; margin-top: 50px"
                     @click="onGetPdfFile(item, index)"></i>
                </el-tooltip>
              </li>
            </ul>
          </div>
          <div v-else> 无附件 </div>
        </el-form-item>

      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header"></template>
      <el-form ref="basicInfoForm"
               :model="detail"
               size="medium"
               label-width="120px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="付款状态："><span> 已退款 </span></el-form-item>
            <el-form-item label="退款金额合计："><span> ￥{{ detail.refund_amount_total }} </span></el-form-item>
            <el-form-item label="退款日期："><span> {{ detail.refund_date | formatExpectedDate }} </span></el-form-item>
            <el-form-item label="日志："><span> {{ detail.log }} </span></el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
    <el-button type="primary" @click="$router.back()">返回</el-button>
    </template>

    <attached-file :visible="attach_file_visible"
                   :file_title="file_title"
                   :url="attach_file_url"
                   @closeDialog="attach_file_visible = false"></attached-file>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'
import moment from 'moment'

import ErrorPanel from '@/components/ErrorPanel'
import AttachedFile from '@/views/payment-manager/components/AttachedFile'
export default {
  components: {
    ErrorPanel,
    AttachedFile
  },
  filters: {
    formatExpectedDate (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  },
  mixins: [],
  data () {
    return {
      onDownloadPdf: false,
      showErrorMsg: true,
      detailErrorMsg: '',
      detail: {
        id: null,
        department_name: null,
        refund_desc: null,
        payment_apply_id: null,
        payment_company_account: null,
        paid_to_type: null,
        paid_to_type_name: null,
        apply_payment_type: null,
        apply_payment_type_name: null,
        refund_amount_total: null,
        attached_file: [],
        refund_date: null,
        log: null,
        bank_account_snapshot: {
          name: null,
          bank_account: null,
          bank: null,
          bank_headquarters: null,
          remark: null,
        },
        creator: {
          id: null,
          name: null,
          user_name: null,
        },
        payment_company_info: {
          name: null,
        },
        refund_detail: [
          {
            id: null,
            payment_refund_id: null,
            payment_apply_detail_id: null,
            refund_amount: null,
            refund_date: null,
            remain_refund: null,
            created_at: null,
            refund_detail_id: null,
            apply_detail_id: null,
            project_id: null,
            department_id: null,
            first_subject: null,
            second_subject: null,
            invoice_type: null,
            tax_rate: null,
            invoice_count: null,
            desc: null,
            finance_desc: null,
            paid_amount: null,
            department_name: null,
            first_subject_name: null,
            second_subject_name: null,
            invoice_type_name: null,
            project_display: null,
          }
        ],
      },
      forFinance: this.$route.meta.type === 'finance',
      attach_file_visible: false,
      file_title: '',
      attach_file_url: '',
    }
  },
  computed: {
    ...Vuex.mapState({}),
    tablePath () {
      return this.forFinance ? '/payment-refund/finance/table' : '/payment-refund/table'
    },
    paymentDetailPath () {
      return this.forFinance ? '/payment-approval/detail' : '/payment-manager/detail'
    }
  },
  created () {
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    setDetailData (id) {
      request('getPaymentRefundDetail', {id, forFinance: this.forFinance ? 1 : 0}).then(({data}) => {
        this.setupLog(data)
        this.detail = data
        this.setupAttachedFile()
        this.showErrorMsg = false
      }).catch((e) => {
        this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
        this.showErrorMsg = true
      })
    },
    setupLog (data) {
      data.log = data.log.reduce((total, item) => {
        return total + `${item.created_at} ${item.admin_name}/${item.admin_real_name || '-'} ${item.desc}\n`
      }, '')
    },
    setupAttachedFile () {
      // 申请的 附件
      this.detail.attached_file.forEach((file, index) => {
        if (file.type === 'pic') {
          request.common('getFinCenterFileUrl', file).then((res) => {
            this.$set(this.detail.attached_file[index], 'pic_url', res.data)
          })
        }
      })
    },
    onGetPdfFile (item) {
      this.$confirm('下载查看文件', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '下载',
        cancelButtonText: '查看',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': getToken()
        })
      }).catch(action => {
        if (action === 'cancel') {
          this.tryOpenAttachFile(item)
        }
      })
    },
    tryOpenAttachFile (item) {
      if (item.type === 'pdf') {
        request.common('getFinCenterFileUrl', item).then(({data}) => {
          window.open(data)
        })
      } else if (item.type === 'eml') {
        this.attach_file_url = request.items.getFinCenterFileUrlForDownload(item)
        this.file_title = item.title
        this.attach_file_visible = true
      } else {
        this.$message({
          type: 'error',
          message: '暂不支持预览操作',
        })
      }
    },
    downloadRefundPDF () {
      this.onDownloadPdf = true
      downloadJS(request.items.downloadRefundPdfFile({id: this.id}), false, false, {
        'SJ-Auth-Token': getToken()
      }, () => {
        this.onDownloadPdf = false
      })
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.el-form-item{
  margin-bottom: 0;
}

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;

  ul {
    transform: translateX(0px);
    transition: all 0.3s;
    box-sizing: content-box;
    // height: 100px;
    overflow: hidden;
    padding: 1px 0;

    li {
      float: left;
      list-style: none;
      width: 100px;
      height: 100px;
      margin-right: 5px;
      cursor: pointer;
      font-size: 0;
      line-height: 0;
      overflow: hidden;
      transition: opacity 0.15s;
    }
  }
}

</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/payment-refund/pages/PaymentRefundDetail.vue